<template>
  <div class="v-checkbox-group" ref="input">
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default() {
        return [];
      }
    },
    selectKey: {
      default: null
    }
  },
  computed: {
    join() {
      return "join" in this.$attrs ? this.$attrs.join || "," : "";
    },
    selected: {
      get() {
        return (this.value instanceof Array
          ? this.value
          : this.join ? String(this.value).split(this.join) : [this.value]
        ).filter(o => !(o == null || o === ""));
      },
      set(value) {
        value = this.join ? value.join(this.join) : value;
        this.$emit("input", value), this.$emit("change", value);
      }
    }
  }
};
</script>

<style lang="less">
.v-checkbox-group {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/checkbox/group.vue